import { render, staticRenderFns } from "./CartSale.vue?vue&type=template&id=0fb0f03e&scoped=true"
import script from "./CartSale.vue?vue&type=script&lang=js"
export * from "./CartSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb0f03e",
  null
  
)

export default component.exports